import { useState } from 'react';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import {
  SectionLayout,
  SectionLayoutSkeleton,
} from '@/components/ui/SectionLayout.tsx';
import NoItems from '@/components/ui/NoItems.tsx';
import { InfoCardList, InfoCardRow } from '@/components/ui/InfoCard.tsx';
import useGetDefaultCurrency from '@/features/dashboard/paymentConfig/hooks/useGetDefaultCurrency.ts';
import EditDefaultCurrencyModal from '@/features/dashboard/paymentConfig/components/EditDefaultCurrencyModal.tsx';
import { getCurrencyLabel } from '@/features/dashboard/paymentConfig/types/Currency.utils.ts';

const DefaultCurrencySection = () => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { data, isLoading } = useGetDefaultCurrency();

  if (isLoading) {
    return <SectionLayoutSkeleton rows={1} />;
  }

  const currency = data?.currency;

  return (
    <>
      <SectionLayout
        title="Domyślna waluta"
        description="Podpowiadana przy nowym wyjeździe i konfiguracji opcji dodatkowych."
      >
        {currency ? (
          <InfoCardList>
            <InfoCardRow
              layout="columns"
              label="Waluta"
              action={
                <ActionButton
                  tone="outline"
                  size="toolbar"
                  onClick={() => setIsEditModalOpen(true)}
                >
                  Zmień
                </ActionButton>
              }
            >
              {getCurrencyLabel(currency)}
            </InfoCardRow>
          </InfoCardList>
        ) : (
          <NoItems
            title="Brak waluty"
            description="Wybierz domyślną walutę, w której uczestnicy będą dokonywać płatności."
          >
            <ActionButton
              tone="outline"
              size="toolbar"
              onClick={() => setIsEditModalOpen(true)}
            >
              Ustaw walutę
            </ActionButton>
          </NoItems>
        )}
      </SectionLayout>
      {isEditModalOpen && (
        <EditDefaultCurrencyModal
          currentCurrency={currency}
          onClose={() => setIsEditModalOpen(false)}
        />
      )}
    </>
  );
};

export default DefaultCurrencySection;
